module.exports = __webpack_public_path__ + "img/chart.c20cbd7d.png";